import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-start gap-5" }
const _hoisted_2 = { class: "flex items-center gap-2 h-7 mb-[5px]" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_5 = ["inert"]

import { computed, onBeforeUnmount, ref } from 'vue';
import { storeToRefs } from 'pinia';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlStatusBadge from '@/components/LlStatusBadge.vue';
import LlTextField from '@/components/LlTextField.vue';
import CustomFieldsFilter from '@/components/CustomFieldsFilter.vue';
import MatterInvolvingFilter from '@/components/MatterInvolvingFilter.vue';
import type { CustomFieldFilterSelections } from '@/models/customFieldFilterTypes';
import { useMeStore } from '@/services/UserService/useMeStore';
import { QB_CONNECTION_OPTIONS } from '../constants/clientsListConstants';
import { useClientsListStore } from '../stores/useClientsListStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsFilters',
  emits: ["apply-filters", "clear-filters"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const meStore = useMeStore();
const { me, features } = storeToRefs(meStore);
const clientsListStore = useClientsListStore();
const { filters, customFields, loading, activeFilterCount } = storeToRefs(clientsListStore);

const showFilters = ref(true);
const matterTerm = computed(() => me.value?.terms?.Matter || 'Matter');
const canShowOrphans = computed(() => me.value?.role !== 'timekeeper');

const applyFilters = () => {
  filters.value.page = 1;
  emit('apply-filters');
};

// Matches the Matters list: 300ms fired mid-word, 1000ms felt sluggish.
let searchTimeout: ReturnType<typeof setTimeout> | undefined;
const handleSearch = () => {
  clearTimeout(searchTimeout);
  searchTimeout = setTimeout(applyFilters, 500);
};
onBeforeUnmount(() => clearTimeout(searchTimeout));

const handleCustomFieldsChange = (selections: CustomFieldFilterSelections) => {
  filters.value.clientCustomFields = selections;
  applyFilters();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-lg p-3 border [&_.v-field]:bg-white [&_.v-selection-control:not(.v-selection-control--dirty)_.v-icon]:bg-white [&_.v-selection-control:not(.v-selection-control--dirty)_.v-icon]:rounded-sm", showFilters.value ? 'bg-green-50 border-green-200' : 'border-transparent']),
    "data-cy": "clients-filters"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col", { 'min-w-[300px]': showFilters.value }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LlSecondaryButton, {
            variant: "outlined",
            size: "small",
            class: "text-capitalize flex-shrink-0 !h-7",
            "prepend-icon": "mdi-filter-variant",
            "append-icon": showFilters.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
            "aria-label": "Toggle filters",
            "data-cy": "clients-filters-toggle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showFilters.value = !showFilters.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(showFilters.value ? '' : 'Filters'), 1)
            ]),
            _: 1
          }, 8, ["append-icon"]),
          (showFilters.value && _unref(activeFilterCount) > 0)
            ? (_openBlock(), _createBlock(LlSecondaryButton, {
                key: 0,
                variant: "text",
                size: "small",
                color: "error",
                "prepend-icon": "mdi-close",
                class: "!h-7",
                "data-cy": "clients-filters-clear-all-quiet",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('clear-filters')))
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" Clear All ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (showFilters.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(LlTextField, {
                modelValue: _unref(filters).search,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).search) = $event)),
                  handleSearch
                ],
                placeholder: "Search Clients",
                "prepend-inner-icon": "mdi-magnify",
                "data-cy": "client-search-input"
              }, null, 8, ["modelValue"]),
              (_unref(filters).checkQuickbooks)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(LlSelect, {
                      modelValue: _unref(filters).qbConnectionType,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).qbConnectionType) = $event)),
                        applyFilters
                      ],
                      items: _unref(QB_CONNECTION_OPTIONS),
                      "item-title": "title",
                      "item-value": "value",
                      "return-object": false,
                      "hide-details": "",
                      loading: _unref(loading),
                      "data-cy": "clients-filter-qb-connection"
                    }, null, 8, ["modelValue", "items", "loading"])
                  ]))
                : _createCommentVNode("", true),
              (canShowOrphans.value)
                ? (_openBlock(), _createBlock(LlCheckbox, {
                    key: 1,
                    modelValue: _unref(filters).orphans,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_unref(filters).orphans) = $event)),
                      applyFilters
                    ],
                    label: `Show Clients without ${matterTerm.value}s`,
                    class: "mt-2",
                    "data-cy": "clients-filter-orphans"
                  }, null, 8, ["modelValue", "label"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ], 2),
      (!showFilters.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_unref(activeFilterCount) > 0)
              ? (_openBlock(), _createBlock(LlStatusBadge, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(activeFilterCount)) + " " + _toDisplayString(_unref(activeFilterCount) === 1 ? 'filter is' : 'filters are') + " active ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(activeFilterCount) > 0)
              ? (_openBlock(), _createBlock(LlSecondaryButton, {
                  key: 1,
                  variant: "text",
                  size: "small",
                  color: "error",
                  "prepend-icon": "mdi-close",
                  "data-cy": "clients-filters-clear-all",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('clear-filters')))
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" Clear All ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: _normalizeClass(["min-w-[240px] [&_.tw]:w-full [&_.v-autocomplete]:w-full [&_.v-field]:w-full", { 'opacity-50': _unref(filters).orphans }]),
              inert: _unref(filters).orphans || undefined,
              "data-cy": "clients-filter-involving"
            }, [
              _createVNode(MatterInvolvingFilter, {
                form: _unref(filters),
                horizontal: true,
                onMatterInvolvingChange: applyFilters
              }, null, 8, ["form"])
            ], 10, _hoisted_5),
            (_unref(features)?.customFieldFilters)
              ? (_openBlock(), _createBlock(CustomFieldsFilter, {
                  key: 0,
                  fields: _unref(customFields),
                  "model-value": _unref(filters).clientCustomFields,
                  "onUpdate:modelValue": handleCustomFieldsChange
                }, null, 8, ["fields", "model-value"]))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ], 2))
}
}

})